import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	getProfitAndLossFailure,
	getProfitAndLossResponceChanged,
	getProfitAndLossSuccess,
} from './profit-and-loss.action';
import ProfitAndLossTypes from './profit-and-loss.types';
import { prifitAndLossDetailsget } from './profit-and-loss.service';
/******************GET PROFIT AND LOSS *********************/
export function* GetProfitAndLossDetails({ payload }: any) {
	try {
		const {
			companyID,
			infogCompanyID,
			AccountHeadID,
			databaseName,
			FilterHOTrxn,
			userAccessBranchID,
			AsOnDate,
			FromDate,
			ToDate,
			BranchID,
		} = payload;
		const key = 'GetProfitAndLossListKey';
		const jsonData = {
			companyID: companyID,
			infogCompanyID: infogCompanyID,
			AccountHeadID: AccountHeadID,
			databaseName: databaseName,
			FilterHOTrxn: FilterHOTrxn,
			userAccessBranchID: userAccessBranchID,
			AsOnDate: AsOnDate,
			FromDate: FromDate,
			ToDate: ToDate,
			branchId: BranchID,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(prifitAndLossDetailsget, encodeData); // data received
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getProfitAndLossFailure(responseData.data));
		} else {
			yield put(getProfitAndLossSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getProfitAndLossFailure(error));
	}
}
export function* resetProfitAndLossResponse() {
	yield put(getProfitAndLossResponceChanged());
}

export function* onProfitAndLossDetails() {
	yield takeLatest(ProfitAndLossTypes.GET_PROFIT_AND_LOSS_START, GetProfitAndLossDetails);
}

export function* onProfitAndLossResponseReset() {
	yield takeLatest(
		ProfitAndLossTypes.GET_PROFIT_AND_LOSS_RESPONSE_RESET,
		resetProfitAndLossResponse,
	);
}
/******************GET PROFIT AND LOSS *********************/

export function* ProfitAndLossFinanceSaga() {
	yield all([call(onProfitAndLossDetails), call(onProfitAndLossResponseReset)]);
}
